<template>
  <div class="login">
    <form v-if="!nextStep" class="login__form" @submit.prevent>
      <use-svg svg="onewind-logo-login" class="login__onewind-logo" />

      <h2 class="login__header">
        Reset Password - Step 1
      </h2>

      <p v-if="extraInformation">
        {{ extraInformation }}
      </p>
      <p>Please enter your username. You will then get a code in your email, this code has to be entered on the next page.</p>

      <base-input
        id="login-username"
        v-model="username"
        class="login__input-containers"
        placeholder="SKF user ID"
        label-text="Enter SKF user ID"
        :label-text-dark="true" />

      <base-button text="send" @click="requestPassword()" />
    </form>

    <form v-if="nextStep" class="login__form" @submit.prevent>
      <use-svg svg="onewind-logo-login" class="login__onewind-logo" />

      <h2 class="login__header">
        Reset Password - Step 2
      </h2>
      <p>You should recieve a code in your registered email-address. Please check your spam-folder if you can't find it.</p>
      <p>Enter the code below and choose a new password.</p>
      <base-input
        id="login-code"
        v-model="code"
        class="login__input-containers"
        placeholder="Code"
        label-text="Enter Code"
        :label-text-dark="true" />
      <base-input
        id="login-password"
        v-model="password"
        class="login__input-containers"
        placeholder="Password"
        label-text="Enter password"
        type="password"
        :error-message="passwordError"
        :label-text-dark="true" />

      <p>The password has to contain numbers, uppercase characters and lowercase characters.</p>

      <base-button text="confirm" @click="confirmPassword()" />
    </form>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'

export default {
  name: 'login-forgotten-password',
  props: {
    extraInformation: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      username: '',
      password: '',
      code: '',
      passwordError: '',
      nextStep: false
    }
  },
  methods: {
    requestPassword() {
      this.nextStep = true
      Auth.forgotPassword(this.username.toLowerCase())
        .then(data => console.info(data))
        .catch(err => console.error(err))
    },
    confirmPassword() {
      let continueWithConfirm = true
      if (
        (!this.hasLowerCase(this.password) &&
          this.hasUpperCase(this.password)) ||
        (this.hasLowerCase(this.password) && !this.hasUpperCase(this.password))
      ) {
        this.passwordError =
          'Password has to contain both uppercase and lowercase characters.'
        continueWithConfirm = false
      }

      if (this.password.length < 8) {
        this.passwordError = 'Password has to be atleast 8 characters.'
        continueWithConfirm = false
      }

      if (!/\d/.test(this.password)) {
        this.passwordError = 'Password has to contain numbers.'
        continueWithConfirm = false
      }

      if (continueWithConfirm) {
        Auth.forgotPasswordSubmit(
          this.username.toLowerCase(),
          this.code,
          this.password
        )
          .then(data => {
            this.$router.push('/')
          })
          .catch(err => {
            if(err.message) {
              alert(err.message)
            }else {
              alert(err)
            }
          })
      }
    },
    hasLowerCase(str) {
      return /[a-z]/.test(str)
    },
    hasUpperCase(str) {
      return /[A-Z]/.test(str)
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  width: 100%
}
</style>
